import { render, staticRenderFns } from "./ConsultationsCurrent.vue?vue&type=template&id=95d6a20e&"
import script from "./ConsultationsCurrent.vue?vue&type=script&lang=js&"
export * from "./ConsultationsCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports